<script lang="ts">

    import type { Form } from "../Model/Form";
    import FormListItem from "./FormListItem.svelte";

    export let forms: Form[];

</script>

<div class="forms-list">
    {#each forms as form}
    <FormListItem {form} on:click />
    {/each}
</div>